module.exports = __webpack_public_path__ + "img/2c870932bb4305eb3f06f53ec889b17d.png";